{
  "en": {
    "task_assignment": {
      "actions": {
        "confirm": "Mark as done",
        "create": "Task",
        "reopen": "Reopen",
        "update": "Edit task"
      },
      "assignee_types": {
        "customer": "Customer",
        "employee": "Employee",
        "partner": "Partner"
      },
      "attributes": {
        "assignee": "Assignee",
        "assignees": "Assignees",
        "created_at": "Created",
        "due_date": "Due date",
        "project": "Project",
        "published": "Published",
        "status": "Status",
        "task": "Task",
        "unit": "Unit"
      },
      "labels": {
        "add_assignee": "Add an assignee…",
        "add_customers": "Add customers",
        "already_assigned": "This task is already added to this unit.",
        "completed": "Completed",
        "confirm_message": "Are you sure you want to mark this task as done?",
        "customers": "Customers",
        "my_tasks": "My tasks",
        "no_assignees": "No assignees yet.",
        "no_assignments": "No tasks yet.",
        "no_assignments_task": "No assignments for this task yet.",
        "no_assignments_unit": "No tasks for this unit yet.",
        "publish_all": "Publish all",
        "publish_customers": "Publish for each unit's customers",
        "published": "Published",
        "required": "This field is required",
        "select_task": "Select a task",
        "upload_hint": "Upload the requested document(s) to complete this task.",
        "uploaded_documents": "Uploaded documents"
      },
      "statuses": {
        "completed": "Completed",
        "draft": "Draft",
        "pending": "Pending"
      },
      "toasts": {
        "completed": "Task completed",
        "create": "Task created",
        "delete": "Task deleted",
        "uncompleted": "Task reopened",
        "update": "Task updated"
      }
    }
  }
}
